import React from "react";
import { ourTranslators } from "../../assets";
import { Wrapper } from "../styles";
import { CustomDivider } from "../styles/Main.styled";
import { Rate } from "antd";
import { Image } from "../styles/Design";

const TopTranslators = () => {
  return (
    <Wrapper type="container" isCenter isSection >
      <Wrapper style={{ margin: '32px 0' }}>
        <h3>Top Translators</h3>
        <CustomDivider isCenter after />
      </Wrapper>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        margin: '0 -16px',
      }}>
        {ourTranslators.map((translator) => (
          <div
            key={translator.id}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              margin: "1rem",
              width: "377px",
              height: "541.16px",
              padding: "0 0 25px 0",
              border: "1px solid #E5E5E5",
              borderRadius: "8px",
            }}
          >
            <Image
              fit="cover"
              src={translator.image}
              alt={translator.name}
              style={{ borderRadius: "8px" }}
            />
            <h3
              style={{
                fontSize: "18px",
                color: "rgba(0, 0, 0, 0.8)",
                fontWeight: "500",
                lineHeight: "21.94px",
              }}
            >
              {translator.name}
            </h3>
            <span
              style={{
                color: "#787878",
              }}
            >
              {translator.job}
            </span>
            <Rate disabled defaultValue={translator.rate} />
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default TopTranslators;
